import angular from 'angular';
import template from './descarga.component.html';
import './descarga.repository.js';




angular
    .module('Toke')
    .component('appDescarga', {
        template,
        bindings: {
            data: '<'
        },
        controller: DescargaController
    });


DescargaController.$inject = ['descargaRepository'];

function DescargaController(descargaRepository) {

    const vm = this;

    vm.descargaData = {};


    vm.$onInit = function () {

        if (vm.data) {
            vm.descargaData = vm.data;

        } else {
            descargaRepository.getDescarga().then(res => {
                vm.descargaData = res;

            });
        }
    };
}
